import { QueryErrorResetBoundaryProps, useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '~src/hooks/api/constants';
import { UseQueryLocalOptions } from '~src/config/queryClient';
import { getAdminFeedbackCycles } from './requests';
import { AdminFeedbackCycle, AdminFeedbackCycleResponse } from './types';

const useAdminFeedbackCycles = (
  options?: UseQueryLocalOptions<AdminFeedbackCycleResponse, QueryErrorResetBoundaryProps, AdminFeedbackCycle[]>,
) =>
  useQuery({
    queryKey: [QUERY_KEYS.ADMIN_FEEDBACK_CYCLES],
    queryFn: () => getAdminFeedbackCycles(),
    select: (data) => data.items,
    ...options,
  });

export default useAdminFeedbackCycles;
